import React from 'react';
import TpvNCScoreHeader from './TpvNCScoreHeader';
import { Table } from 'antd';

export default function TpvScoreBoard({NCScoreCellColor, NCScoreTableColumns, NCScoreLoading, NCScoreTableData, LandlordStatsTableCol, NCLandLordScoreTableData}) {
  return (
    <div id="tpvScoreBoard" className="m-panel">
        <div className="m-panel__body">
            <TpvNCScoreHeader title="Tpv NC Score" NCScoreCellColor={NCScoreCellColor}/>
                <div className="row m-table__main pb-10">
                    <div className="col-md-8 m-table__responsive overflow-hidden-ant-table">
                        <Table scroll={{ x: false, y: false }} columns={NCScoreTableColumns} loading={NCScoreLoading} dataSource={NCScoreTableData} pagination={false}/>
                    </div>
                    <div className="col-md-4 m-table__responsive overflow-hidden-ant-table">
                        <Table scroll={{ x: false, y: false }} columns={LandlordStatsTableCol} loading={NCScoreLoading} dataSource={NCLandLordScoreTableData} pagination={false}/>
                    </div>
                </div>
        </div>
    </div>
  )
}
